export default "__VITE_ASSET__Dr_cHG53__"